import { ApiUrls } from "appConstants/apis";
import { TermType } from "models/term/TermType";
import { BaseServices } from "./baseServices";

export class TermTypeService extends BaseServices<TermType> {
	constructor() {
		super(TermType);
	}

	async getAvailableTermTypes() {
		return this.list(ApiUrls.terms.getAvailableTermTypes).then(
			(response) => response
		);
	}
}
